/**
 * Composes ReusableDialog + MessageBoxContent for the common message-box case.
 * For custom content, use ReusableDialog with your own content component as children.
 */
import React from "react";
import ReusableDialog from "./ReusableDialog";
import MessageBoxContent from "./MessageBoxContent";

/**
 * Reusable message dialog: dialog shell + message content.
 * Same props as before; internally uses ReusableDialog + MessageBoxContent.
 * @param {boolean} [isBlocking=false] - When true, modal is harder to dismiss (e.g. while loading).
 */
export function ReusableMessageDialog({
  isOpen,
  onClose,
  title = "",
  showHeader = false,
  hideHeaderDivider = false,
  message = "",
  errorMessage = "",
  showDetailsButton = false,
  showOkButton = false,
  variant = "error",
  isLoading = false,
  loadingText = "",
  dialogMinHeight = 40,
  bodyMinHeight = 40,
  isBlocking = false,
}) {
  return (
    <ReusableDialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      showHeader={showHeader}
      hideHeaderDivider={hideHeaderDivider}
      variant={variant}
      dialogMinHeight={dialogMinHeight}
      bodyMinHeight={bodyMinHeight}
      isBlocking={isBlocking}
    >
      <MessageBoxContent
        message={message}
        errorMessage={errorMessage}
        showDetailsButton={showDetailsButton}
        showOkButton={showOkButton}
        onClose={onClose}
        isLoading={isLoading}
        loadingText={loadingText}
      />
    </ReusableDialog>
  );
}

export default ReusableMessageDialog;
